import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import { FaExchangeAlt, FaCreditCard, FaCheck } from "react-icons/fa";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader from "../components/PanelAdsHeader";
import { ListSkeleton } from "../components/Skeleton";
import PanelBankAccounts from "../components/PanelBankAccounts";
import * as actions from "../redux/actions/paymentActions";
import "./styles/PanelPayments.css";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

class PanelPayments extends React.Component {
  state = {
    transfer: false,
    ready: false,
  };

  async componentDidMount() {
    const { user_id, token } = this.props;
    if (!user_id || !token) return;

    const result = await this.props.LoadPayment(user_id, token);
    if (result && result.ok) {
      this.setState({
        transfer: Boolean(result.data.Transfer),
        ready: true,
      });
    } else {
      this.setState({ ready: true });
      alertify.warning(I18n.t((result && result.error) || "try_later"));
    }
  }

  toggle = (field) => () => {
    this.setState({ [field]: !this.state[field] });
  };

  onSave = async () => {
    const { user_id, token } = this.props;
    const result = await this.props.UpdatePayment(
      user_id,
      token,
      this.state.transfer,
      false
    );

    if (result && result.ok) {
      alertify.success(I18n.t("payment_saved"));
    } else {
      alertify.warning(I18n.t((result && result.error) || "try_later"));
    }
  };

  renderMethodLabel() {
    const { transfer } = this.state;
    if (transfer) return I18n.t("payment_method_transfer");
    return I18n.t("payment_method_none");
  }

  render() {
    if (!this.state.ready || this.props.loading) {
      return (
        <PanelLayout>
          <ListSkeleton />
        </PanelLayout>
      );
    }

    const { transfer } = this.state;

    return (
      <PanelLayout>
        <div className="panel-payments-page">
          <PanelAdsHeader
            title={<Translate value="payment_title" />}
            subtitle={<Translate value="payment_subtitle" />}
          />

          <div className="payment-options">
            <button
              type="button"
              className={
                "payment-option" + (transfer ? " payment-option--active" : "")
              }
              onClick={this.toggle("transfer")}
            >
              <span className="payment-option__icon">
                <FaExchangeAlt />
              </span>
              <span className="payment-option__body">
                <span className="payment-option__name">
                  <Translate value="payment_method_transfer" />
                </span>
                <span className="payment-option__desc">
                  <Translate value="payment_transfer_desc" />
                </span>
              </span>
              <span
                className={
                  "payment-option__check" +
                  (transfer ? " payment-option__check--on" : "")
                }
              >
                {transfer && <FaCheck />}
              </span>
            </button>

            <div
              className="payment-option payment-option--disabled"
              aria-disabled="true"
            >
              <span className="payment-option__icon">
                <FaCreditCard />
              </span>
              <span className="payment-option__body">
                <span className="payment-option__name">
                  <Translate value="payment_method_gateway" />
                  <span className="payment-option__badge">
                    <Translate value="coming_soon" />
                  </span>
                </span>
                <span className="payment-option__desc">
                  <Translate value="payment_gateway_desc" />
                </span>
              </span>
            </div>
          </div>

          <div className="payment-summary">
            <span className="payment-summary__label">
              <Translate value="payment_selected" />
            </span>
            <span className="payment-summary__value">
              {this.renderMethodLabel()}
            </span>
          </div>

          <button
            type="button"
            className="payment-save-btn"
            onClick={this.onSave}
            disabled={this.props.saving}
          >
            {this.props.saving ? "..." : I18n.t("save")}
          </button>

          {transfer && <PanelBankAccounts />}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    loading: reducer.payment.loading,
    saving: reducer.payment.saving,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadPayment: (user_id, token) =>
    dispatch(actions.loadItem({ user_id, token })),
  UpdatePayment: (user_id, token, transfer, gateway) =>
    dispatch(actions.updateItem({ user_id, token, transfer, gateway })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelPayments);
